'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n'], ['\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/** @class Viewport
  * A div sized and positioned to exactly
  * cover the screen.
  */
var Viewport = _styledComponents2.default.div(_templateObject);

exports.default = Viewport;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/viewport/viewport.js
// module id = 1317
// module chunks = 0